// extracted by mini-css-extract-plugin
module.exports = {"pintxo-chip-group":"ChipGroup_pintxo-chip-group__kwSZu"};